var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 900",
    style: {
      enableBackground: "new 0 0 900 900"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B2B8CA;}\r\n\t.st1{fill:#C6C6C6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M640.77,700.94l-23.94-417.89c-0.83-14.58-13.39-26.45-28-26.45h-75.78c-6.4-27.72-17.33-58.69-35.65-74.32 c-9.71-8.28-20.57-11.71-32.43-10.21c-22.75,2.91-49.61,20.99-61.19,84.52H314.7c-14.57,0-27.2,11.83-28.15,26.38l-27.31,417.91 c-0.47,7.25,1.95,14.11,6.83,19.31c4.88,5.2,11.56,8.07,18.82,8.07h330.08c7.25,0,13.95-2.86,18.85-8.05 C638.72,715.02,641.19,708.17,640.77,700.94z M446.33,183.58c8.82-1.12,16.64,1.39,23.98,7.65c15.49,13.22,25.22,40.21,31.21,65.37 H395.08C405.43,201.63,427.56,185.99,446.33,183.58z M622.59,709.61c-1.95,2.07-4.66,3.21-7.62,3.21H284.89 c-2.94,0-5.63-1.13-7.55-3.18c-1.92-2.05-2.88-4.81-2.68-7.75l27.31-417.91c0.42-6.47,6.26-11.93,12.74-11.93h66.7 c-1.38,10.74-2.38,22.57-2.92,35.62c-0.03,1.63-0.08,2.94-0.14,3.8l11.13,0.68c0.1-0.9,0.12-2.25,0.18-4 c0.55-13.37,1.57-25.35,2.98-36.1h112.19c4.21,22.17,5.52,39.85,5.55,40.28l11.16-0.85c-0.12-1.63-1.35-18.22-5.27-39.42h72.58 c6.45,0,12.21,5.44,12.58,11.88l23.94,417.9C625.52,704.78,624.54,707.54,622.59,709.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.73,412.87c6.52-0.94,10.98-6.98,10.1-13.52c-0.86-6.55-6.74-11.11-13.23-10.17 c-6.46,0.94-10.99,6.97-10.11,13.53C418.34,409.24,424.28,413.77,430.73,412.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M474.57,413.39c6.41-0.94,11.03-6.93,10.15-13.53c-0.85-6.47-6.85-11-13.28-10.09 c-6.52,0.92-11.08,6.99-10.21,13.46C462.11,409.83,468.07,414.33,474.57,413.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.43,448.1c-4.87,118.52-40.16,147.8-68.95,151.49c-10.72,1.38-20.23-1.69-29.16-9.29 c-40.43-34.5-48.64-146.11-48.74-147.28l-13.56,1.02c0.36,4.88,8.78,118.85,53.65,157.15c11.81,10.06,25.03,14.23,39.46,12.41 c33.98-4.36,75.55-36.55,80.88-164.93c0.03-1.98,0.09-3.56,0.17-4.61l-13.53-0.82C524.53,444.34,524.5,445.97,524.43,448.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.1be72b08.svg";
export { ForwardRef as ReactComponent };